import type { SVGProps } from 'react';

export const ThinArrow = (props: SVGProps<any>) => (
  <svg
    height="13px"
    role="img"
    viewBox="0 0 19 13"
    width="19px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'arrow-left'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-187.000000, -38.000000)">
        <g transform="translate(188.000000, 39.000000)">
          <polyline points="6 0 0 5.5 6 11" stroke={props.fill}></polyline>
          <rect
            fill={props.fill}
            height="1"
            id="Rectangle"
            width="18"
            x="0"
            y="5"
          ></rect>
        </g>
      </g>
    </g>
  </svg>
);
